import {Trans} from '@lingui/macro';
import React from 'react';

import {RuleEditorConditionsGroupsEnum} from '../ruleConditionModel';
import {StyledDropdownGroupTitleWrapper} from './ruleEditorCommons';

/*
 * Types.
 */

interface RuleConditionGroupTitleProps {
  id: RuleEditorConditionsGroupsEnum;
}

/*
 * Component.
 */

export const RuleConditionGroupTitle = ({id}: RuleConditionGroupTitleProps) => (
  <StyledDropdownGroupTitleWrapper>{getTitle(id)}</StyledDropdownGroupTitleWrapper>
);

/*
 * Helpers.
 */

const getTitle = (id: RuleEditorConditionsGroupsEnum) => {
  switch (id) {
    case RuleEditorConditionsGroupsEnum.STATUS:
      return <Trans id="rule-condition-group-title-status">Status</Trans>;

    case RuleEditorConditionsGroupsEnum.INBOX:
      return <Trans id="rule-condition-group-title-inbox">Inbox</Trans>;

    case RuleEditorConditionsGroupsEnum.RECIPIENT:
      return <Trans id="rule-condition-group-title-recipient">Recipient</Trans>;

    case RuleEditorConditionsGroupsEnum.CONTACT:
      return <Trans id="rule-condition-group-title-contact">Contact</Trans>;

    case RuleEditorConditionsGroupsEnum.TAGS:
      return <Trans id="rule-condition-group-title-tags">Tags</Trans>;

    case RuleEditorConditionsGroupsEnum.CONTENT:
      return <Trans id="rule-condition-group-title-content">Content</Trans>;

    case RuleEditorConditionsGroupsEnum.MESSAGE:
      return <Trans id="rule-condition-group-title-message">Message</Trans>;

    case RuleEditorConditionsGroupsEnum.TIME:
      return <Trans id="rule-condition-group-title-time">Time</Trans>;

    case RuleEditorConditionsGroupsEnum.TEAMMATES:
      return <Trans id="rule-condition-group-title-teammates">Teammates</Trans>;

    case RuleEditorConditionsGroupsEnum.EXPRESSION:
      return <Trans id="rule-condition-group-title-expression">Dynamic variables</Trans>;

    case RuleEditorConditionsGroupsEnum.ACCOUNT:
      return <Trans id="rule-condition-group-title-account">Account</Trans>;

    default:
      return id;
  }
};
